import appParameters from '../components/utils/AppParameters';
import apiService from '../services/ApiService';
import storeManager from '../store/StoreManager';
import sessionActions from '../actions/SessionActions';
import modeType from '../constants/ModeConstants';
import configuration from '../constants/Configuration';

const localesManager = {
    data: undefined,
    initialized: false,
    moods: undefined,
    themeCategories: undefined,
    cartoonistCaptions: undefined,

    init() {
        if (configuration.LOAD_LOCAL) {
            const store = storeManager.getStore();
            store.dispatch(sessionActions.setCaptionsLoaded());

            return;
        }

        if (this.initialized)
            return;

        this.initialized = true;

        if (appParameters.getMode() == modeType.EDITOR) {
            this.loadMoods();
            this.loadThemeCategories();
        }

        this.loadCartoonistCaptions();
    },
    language() {
        return appParameters.locale;
    },
    loadMoods() {
        apiService.loadMoods().then(response => {
            this.moods = response;
        });
    },
    loadThemeCategories() {
        apiService.loadThemeCategories().then(response => {
            this.themeCategories = response;
        });
    },
    loadCartoonistCaptions() {
        apiService.loadCartoonistCaptions().then(response => {
            this.cartoonistCaptions = response;

            const store = storeManager.getStore();
            store.dispatch(sessionActions.setCaptionsLoaded());
        });
    },
    getTranslation(captionName, categoryObject) {
        if (!categoryObject)
            return captionName;

        var translationsObject = categoryObject[captionName];

        if (!translationsObject)
            return captionName;

        var translation = translationsObject[this.language()];

        if (translation)
            return translation;

        var englishTranslation = translationsObject['en_US'];

        if (englishTranslation)
            return englishTranslation;
        else
            return captionName;
    },
    getMoodsCaption(captionName) {
        return this.getTranslation(captionName, this.moods);
    },
    getThemeCategoryCaption(captionName) {
        return this.getTranslation(captionName, this.themeCategories);
    },
    getCaption(captionName, category = '') {
        var fullCaption = category.length > 0 ? category + '_' + captionName : captionName;

        if (!this.cartoonistCaptions)
            return fullCaption;

        var translationsObject = this.cartoonistCaptions[this.language()];
        var caption;

        if (translationsObject) {
            caption = translationsObject[fullCaption];

            if (caption)
                return caption;
            else
                return fullCaption;
        } else {
            translationsObject = this.cartoonistCaptions['en_US'];

            if (translationsObject) {
                caption = translationsObject[fullCaption];

                if (caption)
                    return caption;
                else
                    return fullCaption;
            } else
                return fullCaption;
        }
    },
    currentLanguage() {
        return appParameters.locale;
    }
};

export default localesManager;



/** WEBPACK FOOTER **
 ** ./src/locales/LocalesManager.js
 **/